import React, { useCallback } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import Button from 'src/components/atoms/button/Button';
import InputForm from 'src/components/atoms/form/InputForm';
import InputLabelHolder from 'src/components/molecules/form/InputLabelHolder';
import { InputFormProps } from 'src/constants/Interface';

interface CopyInputFromProps {
  inputType2: 'text' | 'password' | 'number';
  inputValue2: string;
  placeholder2: string;
  onChange2: (value: string) => void;
  isError2: boolean;
  isDisabeld2?: boolean;
  hasSearch?: boolean;
  disabledSearch: boolean;
  onSearch?: () => void;
}

type Props = InputFormProps &
  CopyInputFromProps & {
    isRequired: boolean;
    labelName: string;
  };

export const DoubleInputFormBlock = (props: Props) => {
  const {
    labelName,
    isRequired,
    inputType,
    inputValue,
    placeholder,
    onChange,
    isError,
    isDisabeld,
    inputType2,
    inputValue2,
    placeholder2,
    onChange2,
    isError2,
    isDisabeld2,
    hasSearch,
    disabledSearch,
    onSearch,
  } = props;

  const wrapOnSearch = useCallback(() => {
    if (onSearch) {
      onSearch();
    }
  }, [onSearch]);

  return (
    <Container>
      <InputLabelHolder labelName={labelName} isRequired={isRequired} />
      <div className={`input_block ${hasSearch ? 'has-seacrh' : ''}`}>
        <InputForm
          inputType={inputType}
          inputValue={inputValue}
          placeholder={placeholder}
          onChange={onChange}
          isError={isError}
          isDisabeld={isDisabeld}
        />
        <InputForm
          inputType={inputType2}
          inputValue={inputValue2}
          placeholder={placeholder2}
          onChange={onChange2}
          isError={isError2}
          isDisabeld={isDisabeld2}
        />
        {hasSearch && (
          <Button
            type="button"
            isDisabled={disabledSearch}
            clickEvent={wrapOnSearch}
            text="住所取得"
          />
        )}
      </div>
    </Container>
  );
};

DoubleInputFormBlock.defaultProps = {
  disabledSearch: false,
};

const Container = styled.div`
  box-sizing: border-box;
  > .input_block {
    display: flex;
    align-items: center;
    justify-content: space-around;
    > * {
      width: 49%;
    }
    &.has-seacrh {
      ${media.lessThan('medium')`
        flex-wrap: wrap;

        button {
          width: 100%;
          margin-top: 8px;
        }
      `};
      ${media.greaterThan('medium')`
        > * {
          &:not(:last-child) {
            width: auto;
            flex-grow: 2;
          }
          &:last-child {
            margin-left: 8px;
            width: auto;
            flex-shrink: 2;
          }
        }
      `};
    }
  }
`;
export default DoubleInputFormBlock;
